export enum KeyResumenDePago {
  ESTADO = 'Estado',
  BANCO = 'Banco',
  VALOR = 'Valor',
  RECIBO = 'Recibo',
  CODIGO_RESPUESTA = 'Código respuesta',
  REFERENCIA_DE_PAGO = 'Referencia de pago',
  FORMA_PAGO = 'Forma pago',
  ESTADO_PAGO = 'Estado pago',
}
